import React, { useState, Fragment, useRef, useEffect } from 'react';
import { Card, CardBody, CardTitle, CardText, Row, Col, Button, Tooltip } from 'reactstrap';
import MetadataForm from '../container/MetadataForm';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HttpClient from '../../utils/HttpClient';

const ContentEditor2 = ({ url, isExistingTinyDoc, metadata, strings } ) => {

  const HEADER = "<!DOCTYPE html><html><head><meta charset=\"UTF-8\"></head><body>";
  const FOOTER = "</body></html>";
  
  const editorRef = useRef(null);
  const metadataRef = useRef(null);

  const [pdfSize, setPdfSize] = useState(9);
  const [metadataSize, setMetadataSize] = useState(3);
  const [pdfChar, setPdfChar] = useState('+');
  const [tooltipPrev, setTooltipPrev] = React.useState(false);
  const [tooltipPrevShown, setTooltipPrevShown] = React.useState(false);
  const [tooltipNext, setTooltipNext] = React.useState(false);
  const [tooltipNextShown, setTooltipNextShown] = React.useState(false);
  const [tooltipSize, setTooltipSize] = React.useState(false);
  const [editorContent, setEditorContent] = useState('');

  const saveLocalAndRestAPI = async() => {    
    if (editorRef.current) {
      const editor = editorRef.current.getEditor();
      const content = editor.root.innerHTML;
      console.log(content);
      
      const fullContent = HEADER + content + FOOTER;
      const file = new File([fullContent], "tiny.html", { type: 'text/html' });
     
      const httpClient = new HttpClient();

      const meta = JSON.parse(metadataRef.current.getMetadata());
      meta.isEditable = true;

      let docId = null;
      if (isExistingTinyDoc && metadata.id && metadata.id.value) {
        docId = metadata.id.value;
      }
      
      httpClient.upload(meta, file, docId)
      .then(result => {
        file.sent = true;
        alert("Dokumentet har lagrats");
      }).catch(error => {
        console.log(JSON.stringify(error));
        if (error.response && error.response.data && error.response.data.message) {
          console.log(error.response.data.message);
          alert(error.response.data.message);
        }
        else {
          console.error("Failed to send file: " + error);
          alert("Misslyckades att skicka");
        } 
      });
      
    }
  };

  const setContentOnInit = async() => { 
    try {
      const response = await fetch(url);
      const text = await response.text();
      if (isExistingTinyDoc) {
        setEditorContent(text);
      }
      else {
        setEditorContent('<p></p>');
      }
    }
    catch(error) {
      setEditorContent('<p>Something unexpected happened with the editor. Please contact support.</p>');
    }
  }

  useEffect(() => {
    setContentOnInit();
  }, [url]);

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image'],
      ['clean']
    ]
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'align',
    'list', 'bullet',
    'indent',
    'link', 'image'
  ];

  return (

    <>


           
<Row noGutters className="pt-2 pt-md-5 w-100 px-4 px-xl-0 mb-3 position-relative">
       
   <Col key={1} xs={{ order: 1 }} md={{ size: 8, order: 1 }} tag="aside"
                    className="pb-5 mb-5 pb-md-0 mb-md-0 mx-auto mx-md-0">
  <form id = "masoudform2"> 
      <ReactQuill 
        ref={editorRef}
        theme="snow"
        value={editorContent}
        onChange={setEditorContent}
        modules={modules}
        formats={formats}
        style={{ height: '800px', marginBottom: '50px' }}
      />
</form>

    <tbody>
      <table><tr>
        <td> <button onClick={saveLocalAndRestAPI}>Spara i TinyDS</button></td>
        </tr>
     </table>
    </tbody>
    
</Col>
       <Col key={2} xs={{ order: 2 }} md={{ size: 2, order: 2, offset: 1 }} tag="section"
                    className="py-5 mb-5 py-md-0 mb-md-0">
                   <MetadataForm ref={metadataRef}/>
      </Col>

</Row>
       
   
</>
 )
}


export default ContentEditor2;
